<template>
	<div class="slide" :class="computedClass">
		<v-layout row wrap>
			<v-flex xs12 >
				<v-card dark>
					<v-card-text class="px-0 title">
						<img src="@/assets/logo.png" alt="" class="poseidon-logo">
						<div>
							{{returnReadableType}}
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs5>
				<div class="slide--content">
					<div v-if="computedClass === 'events'">
					  <div class="img-2">
					  	<img :src="acfGallery[0].url" alt="">
					  </div>
					  <div class="img-2">
					  	<img :src="acfGallery[1].url" alt="">
					  </div>
					</div>
					<div v-else-if="computedClass === 'kurse'">
					  <div class="img-2">
					  	<img :src="acfGallery[1].url" alt="">
					  </div>
					  <div class="img-2">
					  	<img :src="acfGallery[0].url" alt="">
					  </div>
					  <div class="img-2">
					  	<img :src="acfGallery[3].url" alt="">
					  </div>
					</div>
					<div v-else-if="computedClass === 'reisen'">
					  <div class="img-2">
					  	<img :src="acfGallery[0].url" alt="">
					  </div>
					  <div class="img-2">
					  	<img :src="acfGallery[1].url" alt="">
					  </div>
					</div>
					<div v-else-if="computedClass === 'product'">
					  <div class="img-1 product">
					  	<img :src="this.data.image" alt="">
					  </div>
					</div>
					<div v-else>
					  Not A/B/C
					</div>
				</div>
			</v-flex>
			<v-flex xs7>
				<div class="slide--content content">
					<div v-if="computedClass === 'events'">
						<div class="wrap">
							<p class="date">{{ this.prettyDate( this.data.acf.start_date ) }}</p>
							<h2>{{this.data.title}}</h2>
							<p class="price">{{"CHF " + this.data.acf.kosten}}</p>
							<div class="stoerer">
								<img src="@/assets/stoerer_events.png" alt="">
							</div>
						</div>
					</div>
					<div v-else-if="computedClass === 'kurse'">
					  <div class="wrap">
							<p class="date">{{'Michi hilft dir bei der Terminwahl'}}</p>
							<h2>{{this.data.title}}</h2>
							
							<div class="ssi-logo">
								<img src="@/assets/ssi_logo.png" alt="">
							</div>
						</div>
					</div>
					<div v-else-if="computedClass === 'reisen'">
						<div class="wrap">
							<p class="date">{{ this.prettyDate( this.data.acf.start_date ) }}</p>
							<h2>{{this.data.title}}</h2>
							<p class="price">{{this.data.acf.kosten + " CHF"}}</p>
							<div class="stoerer">
								<img src="@/assets/stoerer_reisen.png" alt="">
							</div>
						</div>
					</div>
					<div v-else-if="computedClass === 'product'">
						<div class="wrap">
							<h2>{{this.data.title}}</h2>
							<div class="price" v-html="this.data.price"></div>
							<div class="stoerer">
								<img src="@/assets/stoerer_produkt.png" alt="">
							</div>
						</div>
					</div>
					<div v-else>
					  Not A/B/C
					</div>
				</div>
			</v-flex>
		</v-layout>
	</div>	
</template>

<script>
	
	import moment from 'moment'

	export default {
		name: "Slide",
		moment: moment,
		props: [
			'data',
			'type'
		],
		computed: {
			acfGallery: function() {
				if(this.type == "kurse"){
					console.log(this.data);
	        		return this.data.acf.kurs_gallerie
	        	} else if(this.type == "reisen"){
	        		return this.data.acf.event_gallerie
	        	} else if(this.type == "events"){
	        		return this.data.acf.event_gallerie
	        	} else if(this.type == "product"){
	        		return this.data
	        	} else {
	        		return ''
	        	}
				
			},

	        computedClass: function () {
	            if ( this.type != null ) {
	                return this.type
	            }
	            return 'defaultClass';
	        },

	        returnReadableType: function() {
	        	if(this.type == "kurse"){
	        		return 'Aktueller Kurs'
	        	} else if(this.type == "reisen"){
	        		return 'Aktuelle Reise'
	        	} else if(this.type == "events"){
	        		return 'Aktueller Event'
	        	} else if(this.type == "product"){
	        		return 'Highlight Produkt'
	        	} else {
	        		return ''
	        	}
	        },
	    },

		data() {
			return {
				photo_gallery: []
			}
		},

		methods: {
			randomByLength: function(len){
				return Math.random() * ( len - 1 ) + 1;
			},

			prettyDate(date){
	            return moment(date, 'DD/MM/YYYY', 'de').format('dd DD MMMM YYYY');
	        }
		},
		created() {
			
		},
		mounted() {
			
		}

	}
</script>

<style scoped>
	.slide{
		margin-top: 10px;
		min-width: 100vw;
		min-height: 100vh;
		max-height: 95vh;
	}

	.card{
		
	}
	
	.poseidon-logo{
		width: auto;
	    height: 100%;
	    display: inline-block;
	    vertical-align: bottom;
	    margin:0 50px;
	}

	.title {
		font-size: 4.8rem !important;
		text-transform: uppercase;
		color: white;
		position:relative;
	}


	.title > div {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 100%;
		line-height: 1.7;
	}

	.card .title {
		font-size: 4.8rem !important;
		display: flex;
		
	}

	.slide--content{
		min-height: 90vh;
		height: 90vh;
		max-height: 90vh;
		position: relative;
	}

	.slide--content.content{
		min-height: 90vh;
		height: 90vh;
		max-height: 90vh;
		position: relative;
		display: flex;	
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		min-width: 100%;
		padding-left: 5%;
		padding-right: 5%;
	    padding-bottom: 30%;

	}

	h2{
		font-family: "Montserrat", sans-serif;
	    font-size: 4rem;
	    line-height: 1;
	    max-width: 80%;
		text-align: left;

	}

	p.date{
		text-align: left;
		font-size: 2.5rem;
		font-weight: 500;
	}
	
	div.price,
	p.price{
		margin-top: 2em !important;
		text-align: left !important;
		font-size: 2.8rem !important;
		font-weight: 700 !important;

	}

	.ssi-logo{
		max-width: 20%;
		position: absolute;
		bottom: 10%;
    	right: 6%;
	}

	.ssi-logo img{
		max-width: 100%;
		height: auto;
	}
	
	.img-1{
		min-height: 90vh;
		max-height: 90vh;
		overflow:hidden;
	}

	.img-1 img {
	    object-fit: cover;
	    height: 90vh;
	    width: auto;
	}

	.img-1.product{
	    overflow: hidden;
	    justify-content: center;
	    align-items: center;
	    display: flex;
	    height: 90vh;
	}

	.img-1 img{
	    width:100%;
	    max-width:100%;
	    height: auto;
	}

	.img-2{
		max-height: 45vh;
		overflow:hidden;
	}

	.img-2 img{
		object-fit:cover;
		width: 100%;
		height: 100%;
	}

	.stoerer{
		position: absolute;
		bottom: 5em;
		right: 2em;
		width:60%;
	}
	

	.stoerer img {
		max-width: 100%;
		height: auto;
	}

</style>


// WEBPACK FOOTER //
// src/components/Slide.vue